import React, { FC } from "react";
import cn from "classnames";
import { RenderList } from "./RenderList";
import { ChapterItem } from "./types";
import { useTranslation } from "react-i18next";

interface Props {
  className?: string;
  sections: ChapterItem[];
}

export const RenderChapter: FC<Props> = ({ className, sections }) => {
  const { t } = useTranslation();

  return (
    <ul className={cn("flex flex-col gap-10", className)}>
      {sections.map(
        ({ id, title, contentFirst, contentLast, list, subsections }) => {
          const label =
            typeof title.label === "string"
              ? title.label
              : t(title.label.i18nKey);

          return (
            <li key={id} className="flex flex-col gap-7">
              <span className={cn("text-purple-base", title.className)}>
                {label}
              </span>

              {contentFirst && <p>{contentFirst}</p>}

              {list && <RenderList list={list} />}

              {subsections && <RenderChapter sections={subsections} />}

              {contentLast && <p>{contentLast}</p>}
            </li>
          );
        }
      )}
    </ul>
  );
};
